import { useSelector } from 'react-redux';
import { getIsLiveData } from '../stores/algo-live/getters';

function useAlgoRunning() {
  const algoRunning = useSelector(getIsLiveData);

  return algoRunning;
}

export default useAlgoRunning;
